/**
 *  @class
 *  @function CollectionTabs
 */

if (!customElements.get('collection-tabs')) {
  class CollectionTabs extends HTMLElement {

    constructor() {
      super();
    }
    connectedCallback() {
      setTimeout(() => {
        this.target = this.dataset.target;
        this.buttons = Array.from(this.querySelectorAll('button'));
        this.container = document.getElementById(this.target);
        this.carouselHelper = this.container?.closest('scroll-carousel-helper');
        
        // Load first collection on init
        if (this.buttons.length > 0) {
          const firstHandle = this.buttons[0].dataset.collection;
          if (firstHandle) {
            this.toggleCollection(firstHandle);
          }
        }
        
        this.buttons.forEach((button, i) => {
          button.addEventListener('click', (event) => {
            let handle = button.dataset.collection;
            [].forEach.call(this.buttons, function(el) {
              el.classList.remove('active');
            });

            button.classList.add('active');

            if (handle) {
              this.toggleCollection(handle);
            }

            event.preventDefault();
          });
        });
      }, 20);
      if (Shopify.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          let index = this.buttons.indexOf(event.target);

          this.buttons[index].dispatchEvent(new Event('click'));
        });
      }
    }
    toggleCollection(handle) {
      let container = document.getElementById(this.target);
      
      // Find the template for this collection
      const template = document.querySelector(`template[data-collection-template="${handle}"]`);
      if (!template) return;
      
      // Clear existing products
      container.innerHTML = '';
      
      // Clone and insert products from template
      const content = template.content.cloneNode(true);
      container.appendChild(content);
      
      // Scroll back to the beginning
      container.scrollLeft = 0;
      
      // Update carousel helper if it exists
      if (this.carouselHelper && this.carouselHelper.checkScrollNeeded) {
        setTimeout(() => {
          // Update item count for the current collection
          const itemCount = parseInt(template.dataset.itemCount || container.children.length);
          this.carouselHelper.itemsCount = itemCount;
          this.carouselHelper.checkScrollNeeded();
        }, 50);
      }
    }
  }
  customElements.define('collection-tabs', CollectionTabs);
}
